import { Image } from "src/@types";
import { OnChangeRange } from "src/@types/form";

export type RangeTuple = readonly [string, string];

export enum QueryParamKeys {
  SEARCH = "company_name",
  MIN_INVESTMENT = "investment_for_start",
  LIST_PRICE = "clone_cost",
  ANNUAL_TURNOVER = "average_turnover",
  MONTHLY_INCOME = "monthly_income",
  BUSINESS_TYPE = "clone_type",
  INDUSTRY = "industry",
  EMPLOYEE_COUNT = "employees",
  YEARS_ON_THE_MARKET = "years_on_market",
  CUSTOMER_COUNT = "customers_count",
}

export enum QueryParamVariableNames {
  SEARCH = "searchValue",
  MIN_INVESTMENT = "selectedMinInvestment",
  LIST_PRICE = "selectedListPrice",
  ANNUAL_TURNOVER = "selectedAnnualTurnover",
  MONTHLY_INCOME = "selectedMonthlyIncome",
  BUSINESS_TYPE = "selectedBusinessType",
  INDUSTRY = "selectedIndustries",
  EMPLOYEE_COUNT = "selectedEmployeeCount",
  YEARS_ON_THE_MARKET = "selectedYearsOnTheMarket",
  CUSTOMER_COUNT = "selectedCustomerCount",
}

export type ParamsObject = Record<QueryParamKeys, string>;

export interface IPriceRangeSlider {
  initialMin: string;
  initialMax: string;
  min: string;
  max: string;
  currency: string;
  onChange: OnChangeRange;
}

export type QueryParamSettingsObject =
  | {
      key: QueryParamKeys;
      variableName: QueryParamVariableNames;
      isMultiple?: boolean;
      separator?: string;
      defaultValue?: RangeTuple | string[];
    }
  | {
      key: QueryParamKeys;
      variableName: QueryParamVariableNames;
      isMultiple?: never;
      separator?: never;
      defaultValue?: never;
    };

export interface IQueryParamsData {
  [QueryParamVariableNames.SEARCH]: string;
  [QueryParamVariableNames.MIN_INVESTMENT]: RangeTuple;
  [QueryParamVariableNames.LIST_PRICE]: RangeTuple;
  [QueryParamVariableNames.ANNUAL_TURNOVER]: RangeTuple;
  [QueryParamVariableNames.MONTHLY_INCOME]: RangeTuple;
  [QueryParamVariableNames.BUSINESS_TYPE]: string[];
  [QueryParamVariableNames.INDUSTRY]: string[];
  [QueryParamVariableNames.EMPLOYEE_COUNT]: string[];
  [QueryParamVariableNames.YEARS_ON_THE_MARKET]: string[];
  [QueryParamVariableNames.CUSTOMER_COUNT]: string;
}

export interface IFilteringItem {
  label: string;
  icon: Image;
}
